import { Link } from 'react-router-dom';

const plans = [
  {
    name: 'スターター',
    price: '50,000',
    unit: '円/月',
    description: 'まずは営業支援を試してみたい方に',
    features: [
      '営業戦略の初回診断',
      '月1回の営業レポート提出',
      'メールサポート（平日）',
      '基本的な営業資料テンプレート提供',
    ],
    accent: false,
  },
  {
    name: 'スタンダード',
    price: '150,000',
    unit: '円/月',
    description: '本格的な営業支援をお求めの方に',
    features: [
      '営業戦略の設計・実行支援',
      '週次での営業進捗レポート',
      '専任担当者による電話・メールサポート',
      '営業資料の作成代行（月5本まで）',
      '月1回のオンライン戦略会議',
    ],
    accent: true,
    recommended: true,
  },
  {
    name: 'プレミアム',
    price: '300,000',
    unit: '円/月',
    description: '営業組織全体の変革を目指す方に',
    features: [
      '営業戦略の全面的な設計・実行支援',
      'リアルタイムでの営業データ分析',
      '専任チームによるフルサポート',
      '営業資料の作成代行（無制限）',
      '週1回のオンライン戦略会議',
      '営業研修・トレーニングの実施',
      'システム導入支援',
    ],
    accent: false,
  },
];

export default function PricingPreview() {
  return (
    <section id="pricing" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-18">
          <p className="text-primary-600 text-sm font-medium tracking-widest mb-3">PRICING</p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            料金プラン
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            御社のニーズに合わせて選べる3つのプランをご用意しています。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {plans.map((plan, idx) => (
            <div
              key={idx}
              className={`relative rounded-lg border-2 p-6 md:p-7 transition-all duration-300 hover:scale-[1.02] ${
                plan.accent
                  ? 'border-primary-500 bg-primary-50/30'
                  : 'border-background-200/70 bg-background-50 hover:border-primary-200'
              }`}
            >
              {plan.recommended && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">
                  おすすめ
                </div>
              )}
              <div className="text-center mb-6">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{plan.name}</h3>
                <div className="flex items-baseline justify-center gap-1 mb-2">
                  <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
                    ¥{plan.price}
                  </span>
                  <span className="text-sm text-foreground-500">{plan.unit}</span>
                </div>
                <p className="text-xs text-foreground-500">{plan.description}</p>
              </div>
              <ul className="flex flex-col gap-3 mb-6">
                {plan.features.map((feature, fidx) => (
                  <li key={fidx} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className={`ri-checkbox-circle-fill mt-0.5 flex-shrink-0 ${plan.accent ? 'text-primary-500' : 'text-accent-500'}`} />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/pricing"
                className={`block w-full py-3 text-sm font-semibold rounded-md text-center whitespace-nowrap cursor-pointer transition-all duration-200 ${
                  plan.accent
                    ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                    : 'border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                詳細を見る
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}